export const headerClass =
  'border-b border-gray-200 pb-2 pr-3 text-start text-xs font-bold uppercase text-gray-600 dark:border-white/20 dark:text-white';
export const cellClass = 'py-2 pr-3 text-sm text-navy-700 dark:text-white';
export const inputCls =
  'w-full rounded-md border border-gray-200 bg-white px-3 py-2 text-sm dark:bg-navy-800 dark:text-white';
export const labelCls =
  'mb-1 block text-xs font-medium text-gray-600 dark:text-white';
export const primaryBtn =
  'rounded bg-brand-500 px-3 py-2 text-sm font-medium text-white hover:bg-brand-600 disabled:opacity-50';
export const secondaryBtn =
  'rounded border border-gray-200 px-3 py-2 text-sm dark:text-white disabled:opacity-50';
export const smallBtn =
  'rounded border border-gray-200 px-2 py-1 text-xs dark:text-white disabled:opacity-50';
export const dangerSmallBtn =
  'rounded bg-red-600 px-2 py-1 text-xs text-white hover:bg-red-700 disabled:opacity-50';

/** '' -> undefined so PATCH bodies omit empty optional inputs. */
export const emptyToUndefined = (value: string): string | undefined =>
  value.trim() === '' ? undefined : value.trim();

/** '' -> null so optional columns can be explicitly cleared. */
export const emptyToNull = (value: string): string | null =>
  value.trim() === '' ? null : value.trim();

/** Comma-separated input -> trimmed array; '' -> null ("no restriction"). */
export const csvToArrayOrNull = (value: string): string[] | null => {
  const items = value
    .split(',')
    .map(item => item.trim())
    .filter(Boolean);
  return items.length ? items : null;
};
